<template>
    <div class="story-primary-wrapper storygrid-stacked-single">

        <div class="primary-article">

            <div class="image" v-if="!noImage" v-on:click="didSelectStory(story.slug)">
                <div class="image-inner" v-bind:style="{ backgroundImage: 'url(' + story.image + ')' }"></div>
            </div>

            <div class="intro">
                <div class="primary-content">
                    <primary-article :slug="fetchPrimary" :hideUpdated="hideUpdated" :story="story" headingSize="small" limitSummary="limitSummary" hideSummary="true"></primary-article>
                </div>

                <div v-if="story && !withinStory">
                    <more-sources :slug="fetchPrimary" :story="story"></more-sources>
                    <alternative-articles :alternatives="fetchAlternatives" :story="story"></alternative-articles>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import { Mixins } from '../mixins'
    import PrimaryArticle from '../partials/PrimaryArticle';
    import MoreSources from '../partials/MoreSources';
    import AlternativeArticles from '../partials/AlternativeArticles';

    export default {
        name: 'StoryStackedSingle',
        props: ['story', 'withinStory', 'hideUpdated', 'noImage'],
        mixins: [Mixins],
        components: {
            PrimaryArticle,
            MoreSources,
            AlternativeArticles
        },
        computed: {
            fetchPrimary() {
                if (this.withinStory) {
                    return this.withinStory
                } else if (this.story.primary_article) {
                    return this.story.primary_article.slug
                }
                return '';
            },

            fetchAlternatives() {
                return this.story.alternative_articles;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';
    @import '../grid.scss';
    
    .primary-article {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .intro {
            display: flex;
            flex-direction: column;
            padding: 1em;
            height: 100%;
            justify-content: space-between;

            @media (max-width: 475px) {
                padding: 0.5em;
            }

            .primary-content {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                margin-bottom: 30px;
                position: relative;
            }

            ::v-deep .intro-heading.small {
              font-size: 15px;
            }

            ::v-deep .intro-reason {
              display: none;
            }

            ::v-deep .status-badge {
              
              .svg-wrapper {
                padding-left: 0;
              }
              .status-label {
                display: none;
              }
            }
        }

        .image {
          width: 100%;
          cursor: pointer;

          .image-inner {
            width: 100%;
            height: 120px;
            border-radius: $border-radius;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 50% 33%;
            @media (max-width: 475px) {
                height: 60px;
            }
          }
        }
    }

</style>